import { render, staticRenderFns } from "./SdRadio.html?vue&type=template&id=32c7b35f&external"
import script from "./SdRadio.ts?vue&type=script&lang=ts&external"
export * from "./SdRadio.ts?vue&type=script&lang=ts&external"
import style0 from "./SdRadio.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports